import React, { useContext } from 'react';
import TimezoneSelect from './TimezoneSelect';
import { UserContext } from '../../contexts/User';

function TimezoneSelectWrapper({
  // eslint-disable-next-line react/prop-types
  onChange, member, value, disabled,
}) {
  const { activeWorkspace, user } = useContext(UserContext);

  const timezoneOptions = [{
    heading: 'Your timezone',
    description: user.timezone,
    value: user.timezone,
  }];

  if (activeWorkspace) {
    timezoneOptions.push({
      heading: `${activeWorkspace.name} Timezone`,
      description: activeWorkspace.timezone,
      value: activeWorkspace.timezone,
    });
  }

  if (member) {
    timezoneOptions.push({
      heading: `${member?.user.firstName}'s Timezone`,
      description: member?.user.timezone,
      value: member?.user.timezone,
    });
  }

  return (
    <TimezoneSelect
      value={value}
      label="Timezone"
      disabled={disabled}
      onChange={onChange}
      options={timezoneOptions}
      data-testid="timezone"
    />
  );
}

TimezoneSelectWrapper.propTypes = {
  value: TimezoneSelect.propTypes.value,
  onChange: TimezoneSelect.propTypes.onChange,
  member: TimezoneSelect.propTypes.options,
  // disabled: TimezoneSelect.propTypes.disabled,
};

TimezoneSelectWrapper.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  disabled: false,
};

export default TimezoneSelectWrapper;
